// The install's modules and client pages from the deploy's configuration
// (VITE_ZEHN_MODULES, VITE_ZEHN_HOSTS); the rules are in installModules.js.

import { env } from './env.js';
import { allowedHostOrigins, parseHosts, parseModules } from './installModules.js';

/** docs' own module code: the top bar marks it, intents name it. */
export const DOCS_MODULE = 'zehn-docs';

let cached = null;
let cachedHosts = null;

/** `{code, name, url}[]`, read once per page. */
export const installModules = () => {
  if (!cached) cached = parseModules(env('VITE_ZEHN_MODULES'));
  return cached;
};

/** The client's own pages that may frame docs and open its intent pages (exact origins), read once per page. Never modules. */
export const installHosts = () => {
  if (!cachedHosts) cachedHosts = parseHosts(env('VITE_ZEHN_HOSTS'));
  return cachedHosts;
};

/** The origins whose pages may open docs' intent pages (connectToHost's allowedHostOrigins): the module screens, then the client pages. */
export const intentHostOrigins = () => allowedHostOrigins(installModules(), installHosts(), window.location.origin);
